import React, { useEffect, useState } from "react";
import useFetchCompany from "./useFetchCompany";
import { OverlayLoader, Ptag } from "components/core";
import HeaderView from "./HeaderView";
import CashDeposit from "./CashDeposit";
import { OverviewWrapper } from "./styles";
import Footer from "components/v1/Footer";
import useFetchCd from "hooks/useFetchCd";
import CoverageDetails from "./CoverageDetails";
import http from "services/httpService";
import ReminderConfirmationModal from "./ReminderConfirmationModal";
import OverviewJsx from "./OverviewJsx";
import quickLinksBackground from "../../../assets/svgs2026/benefitsBackgroundSvg.svg";

function Overview() {
  const { loading, company } = useFetchCompany();
  const { loading: cdLoading, cdDetail } = useFetchCd({ presist: true });
  const [showDialog, setShowDialog] = useState(false);
  const [claimsData, setClaimsData] = useState(null)
  const [quickLinksBackgroundLoaded, setQuickLinksBackgroundLoaded] = useState(false);

  useEffect(() => {
    const image = new window.Image();

    const markBackgroundReady = async () => {
      try {
        if (image.decode) {
          await image.decode();
        }
        if (document.fonts?.ready) {
          await document.fonts.ready;
        }
      } catch (error) {
        // Continue rendering if the browser cannot decode the asset.
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => setQuickLinksBackgroundLoaded(true));
      });
    };

    image.onload = markBackgroundReady;
    image.onerror = markBackgroundReady;
    image.src = quickLinksBackground;

    if (image.complete) {
      markBackgroundReady();
    }

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, []);

  const sendReminder = async () => {
    const { data } = await http.post("/business/send_reminder_mail_to_employees/");
  };

  if (loading || cdLoading || !quickLinksBackgroundLoaded) {
    return <OverlayLoader />;
  }

  return (
    <OverviewWrapper>
      <OverviewJsx cdDetail={cdDetail} setClaimsData={setClaimsData} />
      {/* <HeaderView
        active_employee_count={company.active_employee_count}
        logged_in_employee_count={company.logged_in_employee_count}
        sendReminder={() => setShowDialog(true)}
      />
      <CashDeposit cdDetail={cdDetail} />
      <CoverageDetails products={company.product_details} showClaims={company?.show_claim_summary} />
      <Footer />
      <ReminderConfirmationModal
        open={showDialog}
        sendReminder={sendReminder}
        handleClose={() => setShowDialog(false)}
      /> */}
    </OverviewWrapper>
  );
}

export default Overview;
